/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useRef } from 'react'
import styled from 'styled-components'
import { EditorDispatch } from 'cg/components/documents/editor/slate/reducer'

function usePrevious(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

const CodeTabsWrapper = ({ attributes, children, element }) => {
  const { state, dispatch } = useContext(EditorDispatch) || {}
  const { activeTabs } = state || {}
  const { defaultActiveTab, id } = element
  const previousactiveTabs = usePrevious(activeTabs)

  useEffect(() => {
    if (!previousactiveTabs && !activeTabs) {
      const initializeactiveTabs = {}
      initializeactiveTabs[id] = defaultActiveTab
      dispatch({ type: 'activateTab', payload: initializeactiveTabs })
    }
    if (activeTabs && Object.keys(activeTabs).length && !activeTabs[id]) {
      activeTabs[id] = defaultActiveTab
      dispatch({ type: 'activateTab', payload: activeTabs })
    }
  }, [previousactiveTabs, activeTabs])

  return <CodeTabs>{children}</CodeTabs>
}

export default CodeTabsWrapper

const CodeTabs = styled.div`
  display: block;
  margin: 0px 0px 15px;
`
